import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, withRouter } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";
import _ from "lodash";
import Constants from "../../AppConstants/Constants";
import Layout from "../../Layouts/LayoutMain";
import Wizard from "../../Components/Wizard/Wizard";
import ItemsContainer from "../../Components/Common/ItemsContainer";
import { ContentContainer } from "../../Components/Common/ContentContainer";
import RelatedProducts from "../../Components/Common/RelatedProducts";
import DropdownList from "../../Components/Common/DropdownList";
import WirelessPlanMessage from "../../Components/Common/WirelessPlanMessage";
import { getXsrfToken } from "../../Store/Security/Actions";
import { getProductDetails, setSelectedKitProductId } from "../../Store/Product/Actions";
import { addToCart, updateTempCart } from "../../Store/Cart/Actions";
import { getKits, getPlans, updateKitQuantity } from "../../Store/Catalog/Actions";
import { goNext, onFinish } from "../../Store/Wizard/Actions";

class Kits extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: null,
            fullDescription: null,
            price: null,
            picture: null,
            id: null,
            quantity: 1,
            currentlySelectedId: -1
        };

        this.addToCart = this.addToCart.bind(this);
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.onSubmitFinished = this.onSubmitFinished.bind(this);
        this.showDetails = this.showDetails.bind(this);
        this.closeDetails = this.closeDetails.bind(this);
        this.currentSelection = this.currentSelection.bind(this);
    }

    componentWillMount() {
        const { getKits, getPlans, kits, plans, config: { KITS_CATEGORY_ID, DATA_PLANS_CATEGORY_ID }, i18n, activeCurrency } = this.props;

        if (!kits || kits.length === 0 || kits[0].locale !== i18n.locale || kits[0].currencyCode !== activeCurrency.currencyCode) {
            getKits(KITS_CATEGORY_ID);
        }

        if (!plans || plans.length === 0 || plans[0].locale !== i18n.locale || plans[0].currencyCode !== activeCurrency.currencyCode) {
            getPlans(DATA_PLANS_CATEGORY_ID, false, true);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { selectedProduct } = this.props;
        const { selectedProduct: nextSelectedProduct, selectedKitProductId } = nextProps;

        if (selectedKitProductId && !_.isEqual(selectedProduct, nextSelectedProduct)) {
            this.setState({
                data: nextSelectedProduct,
                id: nextSelectedProduct.id,
                name: nextSelectedProduct.name,
                fullDescription: nextSelectedProduct.fullDescription,
                price: nextSelectedProduct.productPrice.price,
                sku: nextSelectedProduct.sku,
                picture: nextSelectedProduct.defaultPictureModel.fullSizeImageUrl,
                productAttributes: nextSelectedProduct.productAttributes
            });
        }
    }

    componentWillUnmount() {
        // this.props.setSelectedKitProductId(-1);
        const { setSelectedKitProductId, updateTempCart, updateKitQuantity } = this.props;
        // this.props.setSelectedDeviceProductId(-1);
        updateTempCart();
        updateKitQuantity(1);
        setSelectedKitProductId(-1);
    }

    showDetails(data) {
        this.props.getProductDetails(data.id, false, false, true, product => {
            this.setState({
                data: product,
                id: product.id,
                name: product.name,
                fullDescription: product.fullDescription,
                price: product.productPrice.price,
                sku: product.sku,
                picture: product.defaultPictureModel.fullSizeImageUrl,
                productAttributes: product.productAttributes
            });
            this.props.setSelectedKitProductId(data.id);
        });
    }

    currentSelection(id) {
        this.setState({currentlySelectedId: id});
    }

    addToCart() {
        const { wizards, goNext, onFinish, updateTempCart, updateKitQuantity, kitQuantity, config: { KITS_CATEGORY_ID, DATA_PLANS_CATEGORY_ID } } = this.props;
        const { data, id, optionClicked } = this.state;
        let { title, quantity } = this.state;

        if (quantity === 0) {
            alert(I18n.t("alerts.quantity"));
        } else {

            if (data.category.id === KITS_CATEGORY_ID) {
                title = "kit";
            } else if (data.category.id === DATA_PLANS_CATEGORY_ID) {
                title = "plan";
            }

            if (kitQuantity) {
                updateTempCart({ [title]: { [id]: { ...data, quantity: kitQuantity, ...optionClicked } } });
            } else {
                updateKitQuantity(quantity);
                updateTempCart({ [title]: { [id]: { ...data, quantity: quantity } } });
            }

            const { totalSteps, currentStep } = wizards.Kits;

            if (currentStep > 0) {
                document.querySelector(".wizardDetailsQTY").style.backgroundColor = "#eee";
                document.querySelector(".wizardDetailsQTY").readOnly = true;
            }

            // Wizard is finished at the second to last step because the last step is the Cart
            if (currentStep === totalSteps - 1) {
                onFinish("Kits");
            } else {
                goNext("Kits");
            }
            this.closeDetails();
            window.scrollTo(0, 0);
        }
    }

    onQuantityChange(quantity) {
        const { updateKitQuantity } = this.props;

        quantity = quantity === "" ? 0 : parseInt(quantity);
        updateKitQuantity(quantity);
        this.setState({ quantity });
    }

    onSubmitFinished() {
        const { getXsrfToken, history, tempCart, addToCart, updateTempCart, updateKitQuantity } = this.props;

        const items = [];
        let kitId = -1;
        _.each(tempCart, (category, categoryName) => {
            _.each(category, product => {
                const cartItem = {
                    ProductId: product.id,
                    Quantity: product.quantity
                };

                if (categoryName.toLowerCase() === "kits") {
                    kitId = product.id;
                } else {
                    cartItem.KitId = kitId;
                }

                if (product.productAttributeId) {
                    cartItem.AttributeControlIds = [`product_attribute_${product.id}_${product.productAttributeId}_${product.productAttributeMapId}_${product.attributeValueId}`];
                }

                items.push(cartItem);
            });
        });

        getXsrfToken(({ token }) => {
            addToCart({ items, __RequestVerificationToken: token }, true, () => {
                updateTempCart();
                updateKitQuantity(1);
                history.push(Constants.ENDPOINTS.CART);
            });
        });
    }

    closeDetails() {
        this.props.setSelectedKitProductId(-1);
    }

    render() {
        const { kits, plans, selectedProduct, kitQuantity, addToCart, selectedKitProductId } = this.props;
        const { name, picture, price, sku, quantity, fullDescription, productAttributes, data, currentlySelectedId } = this.state;

        return (
            <Layout isAuthenticated={this.props.isAuthenticated}>
                {selectedKitProductId < 1 &&
                <div id="kitsContainer">
                    <h2 className="shop-kits-title"><Translate value="kits.title" /></h2>
                    <Wizard
                        name="Kits"
                        steps={[
                            { name: "kits.wizard.steps.one.title", component: <ItemsContainer items={kits} filter="Kit" wizardName="Kits" wizard={true} addToCart={true} showDetails={this.showDetails} setCurrentId={this.currentSelection}/> },
                            { name: "kits.wizard.steps.two.title", component: <ItemsContainer items={plans} filter="Plan" wizardName="Kits" wizard={true} addToCart={true} qtyReadOnly={true} showDetails={this.showDetails} currentSelection={currentlySelectedId}/> },
                            { name: "kits.wizard.steps.three.title" }
                        ]}
                        onFinished={this.onSubmitFinished}
                    />
                    <WirelessPlanMessage />
                </div>}

                {selectedKitProductId > 0 &&
                <div id="kitsDetailsContainer">
                    <ContentContainer size="lg" containerClassName="product-details-container" style={{ paddingTop: "50px" }}>
                        <div className="row">
                            <div className="col-md-12">
                                <ol className="breadcrumbs">
                                    <li>
                                        <Link to={Constants.ENDPOINTS.KITS} onClick={this.closeDetails}><Translate value="kits.title" /></Link>
                                    </li>
                                    <li>{name}</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row justify-content-around">
                            <div className="col-md-6 col-lg-3">
                                <img alt="Image" src={picture} />
                            </div>
                            <div className="col-md-6 col-lg-9">
                                <h2>{name}</h2>
                                <div className={data.displayStockAvailability ? "product-sku2" : "product-sku"}><span className="part-number"><Translate value="misc.partNumber" />: </span>{sku}</div>
                                {data.displayStockAvailability && data.displayStockQuantity &&
                                    <div className="stock-availability"><span className="availability"><Translate value="misc.availability" />: </span>{data.stockQuantity > data.minStockQuantity ? data.stockQuantity : ""} <Translate value={data.stockQuantity > data.minStockQuantity ? "misc.inStock" : "misc.outOfStock"} /></div>
                                }
                                {data.displayStockAvailability && !data.displayStockQuantity &&
                                    <div className="stock-availability"><span className="availability"><Translate value="misc.availability" />: </span><Translate value={data.stockQuantity > data.minStockQuantity ? "misc.inStock" : "misc.outOfStock"} /></div>
                                }
                                {/* conditional for wireless plan options dropdown or regular product price */}
                                {productAttributes && productAttributes.length > 0 ?
                                    <div>
                                        <div className="dropdown carrier-dropdown">
                                            <span className="dropdown__trigger"><span className="plan-dropdown-trigger"><Translate value="dataPlans.select2" /></span><i className="stack-down-open"/></span>
                                            <div className="dropdown__container">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-md-3 col-lg-2 dropdown__content">
                                                            <ul className="menu-vertical">
                                                                <DropdownList productAttributes={productAttributes[0]} product={this.state} selectOption={this.selectOption} />
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="text-block">
                                        <span className="h4 inline-block">{price}</span>
                                    </div>
                                }
                                <div className="product-details-content" dangerouslySetInnerHTML={{ __html: fullDescription }}/>
                                {addToCart &&
                                <div className="row" style={{ marginTop: 15 }}>
                                    <div className="col-4" style={{ paddingLeft: 0 }}>
                                        <Link to={Constants.ENDPOINTS.KITS} onClick={this.closeDetails}><Translate value="kits.title" /></Link>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>

                        {/* related products */}
                        { selectedProduct.relatedProducts && selectedProduct.relatedProducts.length > 0 &&
                        <section>
                            <div className="container related-products-container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-block">
                                            <h3><Translate value="relatedProducts.title" /></h3>
                                        </div>
                                    </div>
                                    <RelatedProducts product={selectedProduct} showDetails={this.showDetails} />
                                </div>
                            </div>
                        </section>
                        }

                    </ContentContainer>
                </div>}
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        activeCurrency: state.activeCurrency,
        cart: state.cart,
        tempCart: state.tempCart,
        wizards: state.wizards,
        kitQuantity: state.kitQuantity,
        kits: state.kits,
        plans: state.plans,
        selectedProduct: state.selectedProduct,
        config: state.config,
        selectedKitProductId: state.selectedKitProductId
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        getKits: getKits,
        getPlans: getPlans,
        addToCart: addToCart,
        updateTempCart: updateTempCart,
        updateKitQuantity: updateKitQuantity,
        goNext: goNext,
        onFinish: onFinish,
        getProductDetails: getProductDetails,
        setSelectedKitProductId: setSelectedKitProductId
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Kits));